module.exports = __webpack_public_path__ + "static/media/process-audio.5ffa5c1b.gif";